import React, {Component} from 'react';
import {configJSON} from "./config"

/**
 * 主题类
 */
class Theme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            theme: configJSON
        }
    };
}

export default Theme

